import type { FC } from "react";
import Box from "@mui/material/Box";

import { Logo } from "src/components/logo";
import { LayoutRoot } from "src/layouts/auth/classic-layout";

export const SplashScreen: FC = () => (
  <LayoutRoot>
    <Logo />
  </LayoutRoot>
);
